import React from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';

export const ProsConsSection = ({
  pros,
  setPros,
  cons,
  setCons,
  addItem,
  updateItem,
  removeItem,
}) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="flex items-center justify-between mb-3">
              <Label>Pros</Label>
              <Button size="sm" variant="outline" onClick={() => addItem(pros, setPros)}>
                <Plus className="h-3 w-3 mr-1" />
                Add Pro
              </Button>
            </div>
            {pros.map((pro) => (
              <div key={pro.id} className="flex gap-2 mb-2">
                <Input
                  placeholder="Enter a pro"
                  value={pro.value}
                  onChange={(e) => updateItem(pros, setPros, pro.id, e.target.value)}
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeItem(pros, setPros, pro.id)}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>

          <div>
            <div className="flex items-center justify-between mb-3">
              <Label>Cons</Label>
              <Button size="sm" variant="outline" onClick={() => addItem(cons, setCons)}>
                <Plus className="h-3 w-3 mr-1" />
                Add Con
              </Button>
            </div>
            {cons.map((con) => (
              <div key={con.id} className="flex gap-2 mb-2">
                <Input
                  placeholder="Enter a con"
                  value={con.value}
                  onChange={(e) => updateItem(cons, setCons, con.id, e.target.value)}
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeItem(cons, setCons, con.id)}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};